var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-card",
        {
          staticClass: "rounded-lg",
          attrs: { loading: _vm.loading || _vm.saving },
        },
        [
          _c(
            "v-tabs",
            {
              model: {
                value: _vm.tab,
                callback: function ($$v) {
                  _vm.tab = $$v
                },
                expression: "tab",
              },
            },
            [
              _c("v-tab", [_vm._v("General")]),
              _c("v-tab", [_vm._v("Meeting Entry")]),
              _c("v-tab", [_vm._v("Exit Screen")]),
              _c("v-tab", [_vm._v("Branding")]),
              _c("v-tab", [_vm._v("Host Profile")]),
            ],
            1
          ),
          _c(
            "v-card-title",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-2",
                          attrs: { text: "", color: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.$router.push("/admin/rooms")
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { color: "primary" } }, [
                            _vm._v("mdi-arrow-left"),
                          ]),
                          _vm._v(" Rooms "),
                        ],
                        1
                      ),
                      _vm._v(
                        " / " +
                          _vm._s(
                            _vm.room_id == "new" ? "New Room" : "Edit Room"
                          ) +
                          " "
                      ),
                    ],
                    1
                  ),
                  _vm.userIsAdmin()
                    ? _c(
                        "v-col",
                        { staticClass: "text-right", attrs: { cols: "3" } },
                        [
                          _c("v-switch", {
                            staticClass: "mt-1",
                            attrs: {
                              dense: "",
                              "hide-details": "",
                              inset: "",
                              label: "Default Room",
                              color: "primary",
                              disabled: _vm.room.default_room,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.toggleDefaultRoom()
                              },
                            },
                            model: {
                              value: _vm.room.default_room,
                              callback: function ($$v) {
                                _vm.$set(_vm.room, "default_room", $$v)
                              },
                              expression: "room.default_room",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.userIsAdmin()
                    ? _c(
                        "v-col",
                        { staticClass: "text-right", attrs: { cols: "3" } },
                        [
                          _c("v-switch", {
                            staticClass: "mt-1",
                            attrs: {
                              dense: "",
                              "hide-details": "",
                              inset: "",
                              label: "Preset",
                              color: "primary",
                            },
                            model: {
                              value: _vm.room.settings.preset,
                              callback: function ($$v) {
                                _vm.$set(_vm.room.settings, "preset", $$v)
                              },
                              expression: "room.settings.preset",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-tabs-items",
            {
              staticClass: "fill-height",
              model: {
                value: _vm.tab,
                callback: function ($$v) {
                  _vm.tab = $$v
                },
                expression: "tab",
              },
            },
            [
              _c(
                "v-tab-item",
                [
                  _c(
                    "v-card-text",
                    [
                      _c("field-label", {
                        attrs: {
                          label: "Room Name",
                          help_text:
                            "Identify your room, for yourself and others.",
                        },
                      }),
                      _c("v-text-field", {
                        attrs: {
                          color: "accent",
                          outlined: "",
                          rules: [_vm.rules.required],
                        },
                        model: {
                          value: _vm.room.post_title,
                          callback: function ($$v) {
                            _vm.$set(_vm.room, "post_title", $$v)
                          },
                          expression: "room.post_title",
                        },
                      }),
                      false && _vm.userIsAdmin()
                        ? [
                            _c("field-label", {
                              attrs: {
                                label: "Room Type",
                                help_text:
                                  "Your room can be primarily for small meetings or live streaming to a group of viewers.",
                              },
                            }),
                            _c(
                              "v-radio-group",
                              {
                                attrs: { row: "" },
                                model: {
                                  value: _vm.room.settings.room_type,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.room.settings,
                                      "room_type",
                                      $$v
                                    )
                                  },
                                  expression: "room.settings.room_type",
                                },
                              },
                              [
                                _c("v-radio", {
                                  attrs: { label: "Meeting", value: "meeting" },
                                }),
                                _c("v-radio", {
                                  attrs: {
                                    label: "Webinar/Livestream",
                                    value: "livestream",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                      _c("field-label", {
                        attrs: {
                          label: "URL/Slug",
                          help_text:
                            "This will serve as the direct link to the room.",
                        },
                      }),
                      _c("v-text-field", {
                        attrs: {
                          outlined: "",
                          messages:
                            "Your entry will automatically be adjusted based on availability and allowed characters.",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "prepend-inner",
                            fn: function () {
                              return [
                                _c("div", { staticClass: "mt-1" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.windowLocationOrigin) +
                                      "/ "
                                  ),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "append",
                            fn: function () {
                              return [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      icon: "",
                                      href: `/${_vm.room.post_name}`,
                                      target: "_blank",
                                    },
                                  },
                                  [_c("v-icon", [_vm._v("mdi-open-in-new")])],
                                  1
                                ),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { icon: "" },
                                    on: { click: _vm.copyURL },
                                  },
                                  [_c("v-icon", [_vm._v("mdi-content-copy")])],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.room.post_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.room, "post_name", $$v)
                          },
                          expression: "room.post_name",
                        },
                      }),
                      _c("field-label", {
                        attrs: {
                          label: "Description",
                          help_text:
                            "Let guests and others know what this room is used for.",
                        },
                      }),
                      _c("v-text-field", {
                        attrs: { outlined: "" },
                        model: {
                          value: _vm.room.settings.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.room.settings, "description", $$v)
                          },
                          expression: "room.settings.description",
                        },
                      }),
                      _c("field-label", {
                        attrs: {
                          label: "Automatic Recording",
                          help_text:
                            "If turned on, all meetings will be recorded automatically.",
                        },
                      }),
                      _c("v-switch", {
                        staticClass: "mt-1 mb-8",
                        attrs: {
                          dense: "",
                          "hide-details": "",
                          inset: "",
                          label: "Auto-record",
                          color: "primary",
                        },
                        model: {
                          value: _vm.room.settings.autorecord,
                          callback: function ($$v) {
                            _vm.$set(_vm.room.settings, "autorecord", $$v)
                          },
                          expression: "room.settings.autorecord",
                        },
                      }),
                      _c("field-label", {
                        attrs: {
                          label: "Virtual Lobby",
                          help_text:
                            "If turned on, this room will function as a holding place for guests. The name of everyone in the lobby will appear in all other rooms as in the Lobby and can be brought into the other  rooms by their host.",
                        },
                      }),
                      _c("p", [
                        _vm._v(
                          'If turned on, this room will function as a holding place for guests. The name of everyone in this room will appear in all other rooms as in the Lobby and can be brought into the other rooms by their host. People in this room will see a basic screen showing your logo and colors and a "waiting" indicator. People in the room can not see other particpants.'
                        ),
                      ]),
                      _c("v-switch", {
                        staticClass: "mt-1",
                        attrs: {
                          dense: "",
                          "hide-details": "",
                          inset: "",
                          label: "Use as Virtual Lobby",
                          color: "primary",
                        },
                        model: {
                          value: _vm.room.settings.lobby,
                          callback: function ($$v) {
                            _vm.$set(_vm.room.settings, "lobby", $$v)
                          },
                          expression: "room.settings.lobby",
                        },
                      }),
                      _vm.room.settings.lobby == 1
                        ? [
                            _c("v-text-field", {
                              staticClass: "mt-8",
                              attrs: {
                                color: "accent",
                                outlined: "",
                                label:
                                  "Enter an email address to authorize the user for this lobby",
                              },
                              on: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return _vm.addLobbyUser.apply(null, arguments)
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "append",
                                    fn: function () {
                                      return [
                                        _vm.add_lobby_user.length > 0
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: { icon: "" },
                                                on: { click: _vm.addLobbyUser },
                                              },
                                              [
                                                _c("v-icon", [
                                                  _vm._v("mdi-check-circle"),
                                                ]),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                1302363592
                              ),
                              model: {
                                value: _vm.add_lobby_user,
                                callback: function ($$v) {
                                  _vm.add_lobby_user = $$v
                                },
                                expression: "add_lobby_user",
                              },
                            }),
                            _vm.room.settings.lobby_users &&
                            _vm.room.settings.lobby_users.length > 0
                              ? _c("div", [
                                  _vm._v(" Authorized Lobby Viewers "),
                                ])
                              : _vm._e(),
                            _vm._l(
                              _vm.room.settings.lobby_users,
                              function (lobby_user) {
                                return _c(
                                  "div",
                                  { key: lobby_user },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { icon: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeLobbyUser(
                                              lobby_user
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("v-icon", [
                                          _vm._v("mdi-close-circle-outline"),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" " + _vm._s(lobby_user) + " "),
                                  ],
                                  1
                                )
                              }
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                  _c(
                    "v-card-actions",
                    { staticClass: "pa-4" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "error", large: "", text: "" },
                          on: {
                            click: function ($event) {
                              _vm.show_confirm_delete_room = true
                            },
                          },
                        },
                        [_vm._v("Delete Room")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-tab-item",
                [
                  _c(
                    "v-card-text",
                    [
                      _c("field-label", {
                        attrs: {
                          label: "Room Password",
                          help_text:
                            "Guests are required to enter the meeting password if one is set here.",
                        },
                      }),
                      _c("v-text-field", {
                        attrs: { outlined: "" },
                        model: {
                          value: _vm.room.settings.password,
                          callback: function ($$v) {
                            _vm.$set(_vm.room.settings, "password", $$v)
                          },
                          expression: "room.settings.password",
                        },
                      }),
                      _c("field-label", {
                        attrs: {
                          label: "Waiting Room/Entry",
                          help_text:
                            "This settings determines how guests can enter your meeting room.",
                        },
                      }),
                      _c("v-select", {
                        attrs: {
                          outlined: "",
                          items: [
                            {
                              text: "None - Guests can enter immediately upon arrival",
                              value: "none",
                            },
                            {
                              text: "Wait for Host - Guests can enter when a host is present",
                              value: "wait-for-host",
                            },
                            {
                              text: "Host Approval - Guests are admitted manually by the host",
                              value: "host-approval",
                            },
                          ],
                        },
                        model: {
                          value: _vm.room.settings.waiting_room,
                          callback: function ($$v) {
                            _vm.$set(_vm.room.settings, "waiting_room", $$v)
                          },
                          expression: "room.settings.waiting_room",
                        },
                      }),
                      _c("field-label", {
                        attrs: {
                          label: "Guest Email Field Settings",
                          help_text:
                            "You can show the email field for Guest logins and make if required for entry if needed.",
                        },
                      }),
                      _c("v-switch", {
                        staticClass: "mt-1 mb-8",
                        attrs: {
                          dense: "",
                          "hide-details": "",
                          inset: "",
                          label: "Show Email Field",
                          color: "primary",
                        },
                        model: {
                          value: _vm.room.settings.show_email_field,
                          callback: function ($$v) {
                            _vm.$set(_vm.room.settings, "show_email_field", $$v)
                          },
                          expression: "room.settings.show_email_field",
                        },
                      }),
                      _c("v-switch", {
                        staticClass: "mt-1 mb-8",
                        attrs: {
                          dense: "",
                          "hide-details": "",
                          inset: "",
                          label: "Require Email Field",
                          color: "primary",
                        },
                        model: {
                          value: _vm.room.settings.require_email_field,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.room.settings,
                              "require_email_field",
                              $$v
                            )
                          },
                          expression: "room.settings.require_email_field",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-tab-item",
                [
                  _c(
                    "v-card-text",
                    [
                      _c("field-label", {
                        attrs: {
                          label: "Exit Button Text",
                          help_text:
                            "After the meeting ends, the final screen will display this text. Default is 'Thanks for Joining'",
                        },
                      }),
                      _c("v-text-field", {
                        attrs: { outlined: "" },
                        model: {
                          value: _vm.room.settings.exit_button_text,
                          callback: function ($$v) {
                            _vm.$set(_vm.room.settings, "exit_button_text", $$v)
                          },
                          expression: "room.settings.exit_button_text",
                        },
                      }),
                      _c("field-label", {
                        attrs: {
                          label: "Exit Button URL",
                          help_text:
                            "After the meeting ends, the final screen will display this a button. You can add a URL here that will link the button to when clicked.'",
                        },
                      }),
                      _c("v-text-field", {
                        attrs: { outlined: "" },
                        model: {
                          value: _vm.room.settings.exit_button_url,
                          callback: function ($$v) {
                            _vm.$set(_vm.room.settings, "exit_button_url", $$v)
                          },
                          expression: "room.settings.exit_button_url",
                        },
                      }),
                      _c("field-label", {
                        attrs: {
                          label: "Exit Page Image",
                          help_text:
                            "If set, this image is displayed on the exit screen for your room. If one is not supplied, the logo image will be used by default.",
                        },
                      }),
                      _vm.room.settings.exit_image
                        ? _c(
                            "v-card",
                            { staticClass: "pa-6", attrs: { outlined: "" } },
                            [
                              _c(
                                "v-card-text",
                                [
                                  _vm.room.settings.exit_image
                                    ? _c("v-img", {
                                        attrs: {
                                          src: _vm.room.settings.exit_image,
                                          "max-height": "200",
                                          contain: "",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "v-card-actions",
                                [
                                  _c("v-spacer"),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { outlined: "", color: "error" },
                                      on: {
                                        click: function ($event) {
                                          _vm.room.settings.exit_image = null
                                        },
                                      },
                                    },
                                    [_vm._v("Remove Image")]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { outlined: "", color: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openFiles(
                                            _vm.$refs.exit_image_file
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Replace Image")]
                                  ),
                                  _c("v-spacer"),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _c(
                            "v-card",
                            { attrs: { outlined: "" } },
                            [
                              _c(
                                "v-card-text",
                                { staticClass: "text-center" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { text: "", color: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openFiles(
                                            _vm.$refs.exit_image_file
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Upload Exit Image (png, jpg)")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                      _c("div", { staticStyle: { display: "none" } }, [
                        _c("input", {
                          ref: "exit_image_file",
                          attrs: {
                            type: "file",
                            name: "exit_image",
                            hidden: "",
                            accept: _vm.accepted_file_types.join(","),
                          },
                          on: { change: _vm.handleSelectedFiles },
                        }),
                        _c("button", { attrs: { onclick: "open_file()" } }),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-tab-item",
                [
                  _vm.user.hasCapability("manage_brand")
                    ? [
                        _c("v-container", [
                          _c("div", { staticClass: "text-h5 mt-8" }, [
                            _vm._v("Theme/Colors"),
                          ]),
                          _c("div", [
                            _vm._v(
                              "These are the settings for the meeting room colors and logo. You can use a predefined template or use your own settings."
                            ),
                          ]),
                        ]),
                        _c(
                          "v-card",
                          { staticClass: "mt-4 rounded-lg" },
                          [
                            _c(
                              "v-card-text",
                              [
                                _c("field-label", {
                                  attrs: {
                                    label: "Room Templates/Presets",
                                    help_text:
                                      "Predefined room settings to speed up your set up.",
                                  },
                                }),
                                _c("v-select", {
                                  attrs: {
                                    outlined: "",
                                    items: _vm.presets,
                                    "item-text": "post_title",
                                    "item-value": "ID",
                                  },
                                  on: { change: _vm.loadPreset },
                                  model: {
                                    value: _vm.preset,
                                    callback: function ($$v) {
                                      _vm.preset = $$v
                                    },
                                    expression: "preset",
                                  },
                                }),
                                _c("v-switch", {
                                  attrs: {
                                    label: "Show detailed theme settings",
                                  },
                                  model: {
                                    value: _vm.show_detailed_settings,
                                    callback: function ($$v) {
                                      _vm.show_detailed_settings = $$v
                                    },
                                    expression: "show_detailed_settings",
                                  },
                                }),
                                _vm.show_detailed_settings
                                  ? [
                                      _c("field-label", {
                                        attrs: {
                                          label: "Header Logo",
                                          help_text:
                                            "The logo image you want to display in your meeting room.",
                                        },
                                      }),
                                      _vm.room.settings.header_logo
                                        ? _c(
                                            "v-card",
                                            {
                                              staticClass: "pa-6",
                                              attrs: { outlined: "" },
                                            },
                                            [
                                              _c(
                                                "v-card-text",
                                                [
                                                  _c("v-img", {
                                                    attrs: {
                                                      src: _vm.room.settings
                                                        .header_logo,
                                                      "max-height": "75",
                                                      contain: "",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-card-actions",
                                                [
                                                  _c("v-spacer"),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        outlined: "",
                                                        color: "error",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.room.settings.header_logo =
                                                            null
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Remove Image")]
                                                  ),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        outlined: "",
                                                        color: "primary",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.openFiles(
                                                            _vm.$refs.logo_file
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Replace Image")]
                                                  ),
                                                  _c("v-spacer"),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _c(
                                            "v-card",
                                            { attrs: { outlined: "" } },
                                            [
                                              _c(
                                                "v-card-text",
                                                { staticClass: "text-center" },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        text: "",
                                                        color: "primary",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.openFiles(
                                                            _vm.$refs.logo_file
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Upload Logo (png, jpg)"
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                      _c(
                                        "div",
                                        { staticStyle: { display: "none" } },
                                        [
                                          _c("input", {
                                            ref: "logo_file",
                                            attrs: {
                                              type: "file",
                                              name: "header_logo",
                                              hidden: "",
                                              accept:
                                                _vm.accepted_file_types.join(
                                                  ","
                                                ),
                                            },
                                            on: {
                                              change: _vm.handleSelectedFiles,
                                            },
                                          }),
                                          _c("button", {
                                            attrs: { onclick: "open_file()" },
                                          }),
                                        ]
                                      ),
                                      _c("field-label", {
                                        staticClass: "mt-8",
                                        attrs: {
                                          label: "Dark Theme",
                                          help_text:
                                            "Many users prefer a dark theme, however, you have the option to use a light theme if it works better with your color selection or other preference.",
                                        },
                                      }),
                                      _c("v-switch", {
                                        attrs: { label: "Use dark theme" },
                                        model: {
                                          value: _vm.room.settings.dark,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.room.settings,
                                              "dark",
                                              $$v
                                            )
                                          },
                                          expression: "room.settings.dark",
                                        },
                                      }),
                                      _c("field-label", {
                                        attrs: {
                                          label: "Header Color",
                                          help_text:
                                            "This color is used in the top banner of the website, providing the background to your logo image.",
                                        },
                                      }),
                                      _c("v-text-field", {
                                        attrs: {
                                          outlined: "",
                                          messages: "Hex color code",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "append",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        fab: "",
                                                        "x-small": "",
                                                        color:
                                                          _vm.room.settings
                                                            .header_color.hex,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.show_header_color_picker = true
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v(
                                                          "mdi-eyedropper-variant"
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          824431140
                                        ),
                                        model: {
                                          value:
                                            _vm.room.settings.header_color.hex,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.room.settings.header_color,
                                              "hex",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "room.settings.header_color.hex",
                                        },
                                      }),
                                      _c("field-label", {
                                        attrs: {
                                          label: "Background Color",
                                          help_text:
                                            "This is the background of the video area.",
                                        },
                                      }),
                                      _c("v-text-field", {
                                        attrs: {
                                          outlined: "",
                                          messages: "Hex color code",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "append",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        fab: "",
                                                        "x-small": "",
                                                        color:
                                                          _vm.room.settings
                                                            .background_color
                                                            .hex,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.show_background_color_picker = true
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v(
                                                          "mdi-eyedropper-variant"
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          348448036
                                        ),
                                        model: {
                                          value:
                                            _vm.room.settings.background_color
                                              .hex,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.room.settings
                                                .background_color,
                                              "hex",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "room.settings.background_color.hex",
                                        },
                                      }),
                                      _c("field-label", {
                                        attrs: {
                                          label: "Primary Color",
                                          help_text:
                                            "This color is used throughout the site for buttons and other elements and often corresponds to either the header color or logo/brand color.",
                                        },
                                      }),
                                      _c("v-text-field", {
                                        attrs: {
                                          outlined: "",
                                          messages: "Hex color code",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "append",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        fab: "",
                                                        "x-small": "",
                                                        color:
                                                          _vm.room.settings
                                                            .primary_color.hex,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.show_primary_color_picker = true
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v(
                                                          "mdi-eyedropper-variant"
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          362084836
                                        ),
                                        model: {
                                          value:
                                            _vm.room.settings.primary_color.hex,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.room.settings.primary_color,
                                              "hex",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "room.settings.primary_color.hex",
                                        },
                                      }),
                                      _c("field-label", {
                                        attrs: {
                                          label: "Secondary Color",
                                          help_text:
                                            "Used on some functional buttons.",
                                        },
                                      }),
                                      _c("v-text-field", {
                                        attrs: {
                                          outlined: "",
                                          messages: "Hex color code",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "append",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        fab: "",
                                                        "x-small": "",
                                                        color:
                                                          _vm.room.settings
                                                            .secondary_color
                                                            .hex,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.show_secondary_color_picker = true
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v(
                                                          "mdi-eyedropper-variant"
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          4182480932
                                        ),
                                        model: {
                                          value:
                                            _vm.room.settings.secondary_color
                                              .hex,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.room.settings.secondary_color,
                                              "hex",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "room.settings.secondary_color.hex",
                                        },
                                      }),
                                      _c("field-label", {
                                        attrs: {
                                          label: "Accent Color",
                                          help_text:
                                            "This color is used throughout the site for items like form fields in the chat.",
                                        },
                                      }),
                                      _c("v-text-field", {
                                        attrs: {
                                          outlined: "",
                                          messages: "Hex color code",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "append",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        fab: "",
                                                        "x-small": "",
                                                        color:
                                                          _vm.room.settings
                                                            .accent_color.hex,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.show_accent_color_picker = true
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v(
                                                          "mdi-eyedropper-variant"
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          1151096804
                                        ),
                                        model: {
                                          value:
                                            _vm.room.settings.accent_color.hex,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.room.settings.accent_color,
                                              "hex",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "room.settings.accent_color.hex",
                                        },
                                      }),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "v-tab-item",
                [
                  _c("v-container", [
                    _c("div", { staticClass: "text-h5 mt-8" }, [
                      _vm._v("Profile Settings"),
                    ]),
                    _c("div", [
                      _vm._v(
                        "These are the settings for the meeting login screen."
                      ),
                    ]),
                  ]),
                  _c(
                    "v-card",
                    { staticClass: "rounded-lg mt-4" },
                    [
                      _c(
                        "v-card-text",
                        [
                          _c("field-label", {
                            attrs: {
                              label: "Host/Room Login Screen Image",
                              help_text:
                                "If set, this image is displayed on the login screen for your room.",
                            },
                          }),
                          _vm.room.settings.profile_image
                            ? _c(
                                "v-card",
                                {
                                  staticClass: "pa-6",
                                  attrs: { outlined: "" },
                                },
                                [
                                  _c(
                                    "v-card-text",
                                    [
                                      _vm.room.settings.profile_image
                                        ? _c("v-img", {
                                            attrs: {
                                              src: _vm.room.settings
                                                .profile_image,
                                              "max-height": "200",
                                              contain: "",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-card-actions",
                                    [
                                      _c("v-spacer"),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            outlined: "",
                                            color: "error",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.room.settings.profile_image =
                                                null
                                            },
                                          },
                                        },
                                        [_vm._v("Remove Image")]
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            outlined: "",
                                            color: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openFiles(
                                                _vm.$refs.profile_image_file
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("Replace Image")]
                                      ),
                                      _c("v-spacer"),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "v-card",
                                { attrs: { outlined: "" } },
                                [
                                  _c(
                                    "v-card-text",
                                    { staticClass: "text-center" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { text: "", color: "primary" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openFiles(
                                                _vm.$refs.profile_image_file
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "Upload Profile Image (png, jpg)"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                          _c("div", { staticStyle: { display: "none" } }, [
                            _c("input", {
                              ref: "profile_image_file",
                              attrs: {
                                type: "file",
                                name: "profile_image",
                                hidden: "",
                                accept: _vm.accepted_file_types.join(","),
                              },
                              on: { change: _vm.handleSelectedFiles },
                            }),
                            _c("button", { attrs: { onclick: "open_file()" } }),
                          ]),
                          _c("field-label", {
                            staticClass: "mt-4",
                            attrs: {
                              label: "Host Profile Name",
                              help_text: "Displayed on the login screen",
                            },
                          }),
                          _c("v-text-field", {
                            attrs: { outlined: "" },
                            model: {
                              value: _vm.room.settings.profile_name,
                              callback: function ($$v) {
                                _vm.$set(_vm.room.settings, "profile_name", $$v)
                              },
                              expression: "room.settings.profile_name",
                            },
                          }),
                          _c("field-label", {
                            attrs: {
                              label: "Host Profile Job Title",
                              help_text: "Displayed on the login screen",
                            },
                          }),
                          _c("v-text-field", {
                            attrs: { outlined: "" },
                            model: {
                              value: _vm.room.settings.profile_job_title,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.room.settings,
                                  "profile_job_title",
                                  $$v
                                )
                              },
                              expression: "room.settings.profile_job_title",
                            },
                          }),
                          _c("field-label", {
                            attrs: {
                              label: "Host Profile Description",
                              help_text: "Displayed on the login screen",
                            },
                          }),
                          _c("v-textarea", {
                            attrs: { "auto-grow": "", rows: "1", outlined: "" },
                            model: {
                              value: _vm.room.settings.profile_description,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.room.settings,
                                  "profile_description",
                                  $$v
                                )
                              },
                              expression: "room.settings.profile_description",
                            },
                          }),
                          _c("field-label", {
                            attrs: {
                              label: "Host Profile Phone Number",
                              help_text: "Displayed on the login screen",
                            },
                          }),
                          _c("v-text-field", {
                            attrs: { outlined: "" },
                            model: {
                              value: _vm.room.settings.profile_phone_number,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.room.settings,
                                  "profile_phone_number",
                                  $$v
                                )
                              },
                              expression: "room.settings.profile_phone_number",
                            },
                          }),
                          _c("field-label", {
                            attrs: {
                              label: "Host Profile Email Address",
                              help_text: "Displayed on the login screen",
                            },
                          }),
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              label: "Profile email address",
                            },
                            model: {
                              value: _vm.room.settings.profile_email_address,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.room.settings,
                                  "profile_email_address",
                                  $$v
                                )
                              },
                              expression: "room.settings.profile_email_address",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card",
            { staticClass: "mt-4 mb-16 rounded-lg" },
            [
              _c(
                "v-card-actions",
                { staticClass: "pa-4" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticClass: "px-8",
                      attrs: {
                        fab: "",
                        color: "primary",
                        large: "",
                        loading: _vm.saving,
                      },
                      on: { click: _vm.saveRoom },
                    },
                    [_c("v-icon", [_vm._v(" mdi-check ")])],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { width: "300", "hide-overlay": "" },
          model: {
            value: _vm.show_header_color_picker,
            callback: function ($$v) {
              _vm.show_header_color_picker = $$v
            },
            expression: "show_header_color_picker",
          },
        },
        [
          _c("v-color-picker", {
            attrs: {
              value: _vm.room.settings.header_color.hexa,
              "show-swatches": "",
              "hide-mode-switch": "",
              mode: "hexa",
              swatches: _vm.swatches,
            },
            on: { "update:color": _vm.previewColorChange },
            model: {
              value: _vm.room.settings.header_color,
              callback: function ($$v) {
                _vm.$set(_vm.room.settings, "header_color", $$v)
              },
              expression: "room.settings.header_color",
            },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { width: "300", "hide-overlay": "" },
          model: {
            value: _vm.show_primary_color_picker,
            callback: function ($$v) {
              _vm.show_primary_color_picker = $$v
            },
            expression: "show_primary_color_picker",
          },
        },
        [
          _c("v-color-picker", {
            attrs: {
              value: _vm.room.settings.primary_color.hex,
              "show-swatches": "",
              "hide-mode-switch": "",
              mode: "hexa",
              swatches: _vm.swatches,
            },
            on: { "update:color": _vm.previewColorChange },
            model: {
              value: _vm.room.settings.primary_color,
              callback: function ($$v) {
                _vm.$set(_vm.room.settings, "primary_color", $$v)
              },
              expression: "room.settings.primary_color",
            },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { width: "300", "hide-overlay": "" },
          model: {
            value: _vm.show_background_color_picker,
            callback: function ($$v) {
              _vm.show_background_color_picker = $$v
            },
            expression: "show_background_color_picker",
          },
        },
        [
          _c("v-color-picker", {
            attrs: {
              value: _vm.room.settings.background_color.hex,
              "show-swatches": "",
              "hide-mode-switch": "",
              mode: "hexa",
              swatches: _vm.swatches,
            },
            on: { "update:color": _vm.previewColorChange },
            model: {
              value: _vm.room.settings.background_color,
              callback: function ($$v) {
                _vm.$set(_vm.room.settings, "background_color", $$v)
              },
              expression: "room.settings.background_color",
            },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { width: "300", "hide-overlay": "" },
          model: {
            value: _vm.show_secondary_color_picker,
            callback: function ($$v) {
              _vm.show_secondary_color_picker = $$v
            },
            expression: "show_secondary_color_picker",
          },
        },
        [
          _c("v-color-picker", {
            attrs: {
              value: _vm.room.settings.secondary_color.hex,
              "show-swatches": "",
              "hide-mode-switch": "",
              mode: "hexa",
              swatches: _vm.swatches,
            },
            on: { "update:color": _vm.previewColorChange },
            model: {
              value: _vm.room.settings.secondary_color,
              callback: function ($$v) {
                _vm.$set(_vm.room.settings, "secondary_color", $$v)
              },
              expression: "room.settings.secondary_color",
            },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { width: "300", "hide-overlay": "" },
          model: {
            value: _vm.show_accent_color_picker,
            callback: function ($$v) {
              _vm.show_accent_color_picker = $$v
            },
            expression: "show_accent_color_picker",
          },
        },
        [
          _c("v-color-picker", {
            attrs: {
              value: _vm.room.settings.accent_color.hex,
              "show-swatches": "",
              "hide-mode-switch": "",
              mode: "hexa",
              swatches: _vm.swatches,
            },
            on: { "update:color": _vm.previewColorChange },
            model: {
              value: _vm.room.settings.accent_color,
              callback: function ($$v) {
                _vm.$set(_vm.room.settings, "accent_color", $$v)
              },
              expression: "room.settings.accent_color",
            },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600", "overlay-opacity": "0.9" },
          model: {
            value: _vm.show_confirm_delete_room,
            callback: function ($$v) {
              _vm.show_confirm_delete_room = $$v
            },
            expression: "show_confirm_delete_room",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [_vm._v("Delete Room?")]),
              _c("v-card-text", [
                _vm._v(
                  "Are you sure you want to delete the room: " +
                    _vm._s(_vm.room.post_title) +
                    "?"
                ),
              ]),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      on: {
                        click: function ($event) {
                          _vm.show_confirm_delete_room = false
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "error", loading: _vm.deleting_room },
                      on: {
                        click: function ($event) {
                          return _vm.deleteRoom()
                        },
                      },
                    },
                    [_vm._v("Delete")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }